import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { trackByFactory } from '@mode/capra';

export interface DropdownItem {
  readonly name: string;
  readonly disabled?: boolean;
}

@Component({
  selector: 'mode-format-dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownListComponent {
  @Input() label = '';
  @Input() selected: DropdownItem | undefined;
  @Input() menuItems: DropdownItem[] = [];
  @Input() menuDisabled = false;

  @Output() selectedChange = new EventEmitter<DropdownItem>();

  trackByName = trackByFactory<DropdownItem>(({ name }) => name);

  selectItem(item: DropdownItem) {
    this.selectedChange.emit(item);
  }
}
